import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'
import ListDelete from './views/ListDelete.vue'

export const RecurringIncidentRoutes = [
  {
    path: '/recurring-incidents',
    name: 'ListRecurringIncidents',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'recurrent_incident:list'
    }
  },
  {
    path: '/recurring-incidents-deletion-request',
    name: 'ListDeleteRecurringIncidents',
    component: ListDelete,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'recurrent_incident:delete'
    }
  },
  {
    path: '/recurring-incident/',
    name: 'CreateRecurringIncident',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'recurrent_incident:create'
    }
  },
  {
    path: '/recurring-incident/:id',
    name: 'UpdateRecurringIncident',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'recurrent_incident:update'
    }
  },
  {
    path: '/recurring-incident/view/:id',
    name: 'GetRecurringIncident',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'recurrent_incident:get'
    }
  }
]
